// MessageCount.tsx
import { Badge, Text } from '@components'
import { api } from '@here/api'
import { useQuery } from '@tanstack/solid-query'
import { Flag } from 'lucide-solid'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'

async function fetchCommanderScore(channelId: string): Promise<number | null> {
	const { data: commanders, error: commandersErr } = await api()
		.from('profile_private')
		.select('id')
		.eq('role', 'commander')

	if (commandersErr) throw commandersErr

	const commanderIds = (commanders ?? []).map((r) => r.id)
	if (!commanderIds.length) {
		// nothing to fetch
		return null
	}

	const { data, error } = await api()
		.from('taken_setups')
		.select('score', { head: false })
		.eq('setup_id', channelId)
		.in('user_id', commanderIds)

	return data && data.reduce((s, r) => s + (r.score ?? 0), 0) / data.length
}

export const CommanderScore = (props: { channelId?: string }) => {
	const q = useQuery(() => ({
		queryKey: ['commader-score-count', props.channelId],
		queryFn: () => fetchCommanderScore(props.channelId!),
		enabled: !!props.channelId,
		staleTime: 30 * 60 * 1000, // 30m cache freshness
		gcTime: 30 * 60 * 1000, // 30m cache retention
		retry: 1,
		placeholderData: 0,
	}))

	return (
		<Show when={q?.data && q?.data > 0}>
			<Badge
        borderRadius='sm'
				size="sm"
				variant="solid"
				justifyContent="center"
        color='tscGreen.10'
        bg="neutralSubtle"
			>
				<Show
					when={!q.isLoading}
					fallback="…"
				>
          <Flag fill='var(--colors-tsc-green-light-10)' />
					<Text size='xs'>PHQ {q.data}</Text>
				</Show>
			</Badge>
		</Show>
	)
}
